import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Alphabet from "./Language/Alphabet";
import LangList from "./LangList/LangList";
import NotFound from "./NotFound";
import PanCyrillic from "./PanCyrillic/PanCyrillic";
import About from "./content/About";
import { getURLstring, makeParams } from "../service/functions";
import DefinitionsContent from "./content/DefinitionsContent";
import { getConfig } from "../service/config";

const ContentField = () => {
    const currentPage = useSelector(state => state.currentPage);
    const rus = useSelector(state => state.rus);
    const currentLang = useSelector(state => state.currentLang);
    const langGroup = useSelector(state => state.langGroup?.script);
    const dispatch = useDispatch();

    useEffect(() => {
        if (langGroup) {
            const jsonPath = getConfig().JSON_PATH;
            let lng = jsonPath + 'site/' + langGroup + '/' + langGroup + '_characters_lib.json';
            let lnglst = jsonPath + 'library/' + langGroup + '/' + langGroup + '_library.json';
            
            fetch(lng)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    dispatch({ type: 'setAllTable', payload: data });
                })
                .catch(error => {
                    console.error('ContentField - error loading characters lib:', error);
                });
                
            fetch(lnglst)
                .then(res => {
                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }
                    return res.json();
                })
                .then(data => {
                    dispatch({ type: 'setLangListNames', payload: data });
                    // Убираем сброс currentLang в null, чтобы не перезаписывать значение из URL
                })
                .catch(error => {
                    console.error('ContentField - error loading library:', error);
                });
        }
    }, [langGroup]);

    useEffect(() => {
        if (!currentPage) {
            let params = makeParams();
            dispatch({ type: 'switchPage', payload: params.currentPage });
            if (params.uiLang) {
                dispatch({ type: 'toggleRuEn', payload: params.uiLang });
            };
            if (params.currentLang) {
                dispatch({ type: 'switchCurrentLang', payload: params.currentLang });
            };
            // Сохраняем langGroup из URL для использования в генерации URL
            if (params.langGroup) {
                // Если в URL указан group, нужно найти соответствующий langGroup в списке
                // и установить его. Это будет сделано в MainMenu после загрузки languages.json
            }
        };
        
        // Используем langGroup из URL параметров, если он есть, иначе используем текущий
        let params = makeParams();
        let urlGroup = params.langGroup || langGroup;
        window.history.pushState(null, null, getURLstring(rus, currentLang, currentPage, urlGroup))
    }, [currentPage, rus, currentLang, langGroup]);


    if (currentPage == 1) return (<>
        <div className='langmenu'><LangList /></div>
        <div className='container'><PanCyrillic /></div>
    </>)
    else if (currentPage == 2) return (<>
        <div className='langmenu'><LangList /></div>
        <div className='container'><Alphabet /></div>
    </>)
    else if (currentPage == 3) return (<>
        <div className='langmenu'>&nbsp;</div>
        <div className='container'><About /></div>
    </>)
    else if (currentPage == 4) return (<>
        <div className='langmenu'>&nbsp;</div>
        <div className='container'><DefinitionsContent /></div>
    </>)
    else return (<NotFound />)

};

export default ContentField;